import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { UserSettingsRoutesConfig } from 'domains/userSettings/Routes';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useIsMDDown } from 'uiKit/Theme/useTheme';
import { usePartnerClientStatus } from 'domains/jwtToken/hooks/usePartnerClientStatus';

export const useRedirectForSmallDevices = () => {
  const history = useHistory();
  const isHidden = useIsMDDown();
  const { isLoggedIn } = useAuth();
  const { isPartnerClient, isPartnerStatusLoading } = usePartnerClientStatus();

  useEffect(() => {
    if (isHidden && !isPartnerStatusLoading) {
      if (isPartnerClient) {
        return history.replace(
          UserSettingsRoutesConfig.settings.generatePath(),
        );
      }

      history.replace(chainsRoutesConfig.chains.generatePath({ isLoggedIn }));
    }
  }, [isHidden, isLoggedIn, history, isPartnerClient, isPartnerStatusLoading]);
};
